import React, { useState, useEffect } from "react"
import { database, firestore, storage, auth } from './../../firebase/utils';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom'
import './styles.scss';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import FormInput from './../../components/forms/FormInput';
import Button from './../../components/forms/Button';
import { useSelector } from "react-redux";

const mapState = ({ user }) => ({
    currentUser: user.currentUser
});

const AddNewProduct = (props) => {
    const { currentUser } = useSelector(mapState);
    const history = useHistory();


    const timestamp = new Date();
    const [pid, setPid] = useState('');
    const [date, setCurrentDate] = useState('');
    const [time, setTime] = useState('');

    useEffect(() => {
        var pid = moment()
            .utcOffset('+01:00')
            .format('YYYYMMDDHHmm');
        setPid(pid);
    }, []);

    useEffect(() => {
        var date = moment()
            .utcOffset('+01:00')
            .format('YYYY/M/DD');
        setCurrentDate(date);
    }, []);

    useEffect(() => {
        var time = moment()
            .utcOffset('+01:00')
            .format('HH:mm');
        setTime(time);
    }, []);


    const [productName, setProductName] = useState('');
    const [productBrand, setProductBrand] = useState('');
    const [stockQty, setStockQty] = useState('');
    const [category, setCategory] = useState('homeappliances');
    const [description, setDescription] = useState('');
    const [productPrice, setProductPrice] = useState('');
    const [error, setError] = useState('');
    const [pweight, setPWeight] = useState('');
    const [images, setImages] = useState([]);
    const [urls, setUrls] = useState([]);
    const [progress, setProgress] = useState(0);
    const [hideBtn, setHideBtn] = useState(true);

    const handleChange = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            const newImage = e.target.files[i];
            newImage["id"] = Math.random();
            setImages((prevState) => [...prevState, newImage]);
        }
    };

    const handleUpload = () => {
        const promises = [];
        images.map((image) => {
            const uploadTask = storage.ref(`images/${image.name}`).put(image);
            promises.push(uploadTask);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(progress);
                },
                (error) => {
                    console.log(error);
                },
                () => {
                    storage
                        .ref("images")
                        .child(image.name)
                        .getDownloadURL()
                        .then((urlss) => {

                            setUrls((prevState) => [...prevState, urlss]);

                        })
                        .then(
                            setHideBtn(false)
                        );
                },

            );
        });

        Promise.all(promises)
            .then(() => alert("Product Image Uploaded Successfully"))
            .catch((err) => console.log(err));



    };

    const handleUploadpd = () => {
        const promisess = [];
        images.map((image) => {
            const uploadTask = storage.ref(`images/${image.name}`).put(image);
            promisess.push(uploadTask);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(progress);
                },
                (error) => {
                    console.log(error);
                },
                async () => {
                    await firestore.collection('Products').doc(pid).set({
                        pname: productName,
                        pbrand: productBrand,
                        price: productPrice,
                        stockqty: stockQty,
                        category: category,
                        weight: pweight,
                        description: description,
                        image: urls,
                        pid: pid,
                        productAdminUserUID: auth.currentUser.uid,
                        createdDate: timestamp

                    }).then(() => {
                        setProductName('');
                        setProductBrand('');
                        setStockQty('');
                        setCategory('');
                        setDescription('');
                        setProductPrice('')
                        setImages([])
                        setCurrentDate('');
                        setPWeight('')
                        setPid('');
                        setTime('');
                        setError('');


                    })

                    await database.ref('Products').child(pid).set({
                        pname: productName,
                        pbrand: productBrand,
                        stockqty: stockQty,
                        price: productPrice,
                        category: category,
                        description: description,
                        weight: pweight,
                        image: urls,
                        pid: pid,
                        date: date,
                        time: time,
                        productAdminUserUID: auth.currentUser.uid,
                        createdDate: timestamp




                    }).then(() => {
                        setProductName('');
                        setProductBrand('');
                        setStockQty('');
                        setCategory('');
                        setDescription('');
                        setProductPrice('')
                        setUrls([])
                        setPWeight('')
                        setCurrentDate('');
                        setPid('');
                        setTime('');
                        setError('');

                    })
                        .catch(err => setError(err.message));

                },
            );
        });

        Promise.all(promisess)
            .then(() => alert("Product Uploaded Successfully"))
            .then(history.goBack)
            .catch((err) => console.log(err));
    };


    return (
        <div className='container'>

            <h2>ADD NEW PRODUCT</h2>
            <hr />
            <p>
                <span className="red">Product ID:</span>{pid}

            </p>

            <label>
                Select Category:
                <select value={category} onChange={(e) => setCategory(e.target.value)}>
                    <option value="inverter">Inverter</option>
                    <option value="battery">Battery</option>
                    <option value="solarpanel">Solar Panel</option>
                    <option value="solarpump">Solar Pump</option>
                    <option value="solarhomeappliances">Solar Home Appliances</option>
                    <option value="solarcctv">Solar CCTV</option>
                    <option value="solarallinonelight">Solar All in One Light</option>
                    <option value="solarlighting">Solar Lighting</option>
                    <option value="solargenerators">Solar Generators</option>
                    <option value="chargecontroller">Charge Controller</option>
                    <option value="windenergy">Wind Energy</option>
                    <option value="solarirrigtionpump"> Solar Irrigtion Pump</option>
                    <option value="solarwaterheater">solarwaterheater</option>
                    {/* <option value="baby">Baby</option>
                    <option value="bags">Bags</option>
                    <option value="automibile">Automibile</option> */}

                </select>
            </label>
            <br />

            <label>
                Select Product Brand:
                <select value={productBrand} onChange={(e) => setProductBrand(e.target.value)}>
                    <option value="schneider">Schneider</option>
                    <option value="magnum">Magnum</option>
                    <option value="outback">Outback</option>
                    <option value="steca">Steca</option>
                    <option value="vutron">Vutron</option>
                    <option value="deka">Deka</option>
                    <option value="monbat">Monbat</option>
                    <option value="trojan">Trojan</option>
                    <option value="hoppecka">Hoppecke</option>
                    <option value="rolls">Rolls</option>
                    <option value="felicity">Felicity</option>
                    <option value="pedrollo">Pedrollo</option>
                    <option value="franklin">Franklin</option>
                    <option value="grumdfos">Grumdfos</option>
                    <option value="canadiansolar">Canadian Solar</option>
                    <option value="evasolar">Eva Solar</option>
                    <option value="jasolar">JA Solar</option>
                    <option value="sunpower">Sun Power</option>
                    <option value="bi-facial">Bi-Facial</option>
                    {/* <option value="automibile">Automibile</option>
                    <option value="automibile">Automibile</option>
                    <option value="automibile">Automibile</option> */}



                </select>
            </label>

            <FormInput
                type="text"
                name="Product Name"
                value={productName}
                required
                placeholder="Product Name"
                handleChange={e => setProductName(e.target.value)}
            />

            <FormInput
                type="number"
                name="Product Price"
                value={productPrice}
                required
                placeholder="Product Price"
                handleChange={e => setProductPrice(e.target.value)}
            />

            <FormInput
                type="number"
                name="Quantity in Stock"
                value={stockQty}
                required
                placeholder="Quantity in Stock"
                handleChange={e => setStockQty(e.target.value)}
            />

            <FormInput
                type="number"
                name="Product Weight"
                value={pweight}
                required
                placeholder='Product Weight'
                handleChange={e => setPWeight(e.target.value)}
            />


            <span className="center m-top">Product Images</span>
            <FormInput
                type="file"
                multiple
                handleChange={handleChange}
            />

            <span className="center m-top m-btm">Product Description</span>
            <CKEditor
                editor={ClassicEditor}
                data="<p>Add product details here</p>"
                onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    setDescription(data)
                }}
                onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                }}
                onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                }}
            />

            <div className="center">
                <span> upload progress</span>
                <progress value={progress} max="100" />
            </div>

            <Button
                onClick={handleUpload}
                className={hideBtn ? 'btn-actn' : 'btn-actn active'}>
                Upload Pictures
            </Button>

            <Button
                // className='btn btn-success btn-md mybtn'
                onClick={handleUploadpd}
                className={hideBtn ? 'btn-actn active' : 'btn-actn'}>
                ADD PRODUCT
            </Button>

            {error && <span className='error-msg'>{error}</span>}
        </div>
    )
}

export default AddNewProduct;